export default __webpack_public_path__ + "img/678ef24cc6644c81857740411592073b.svg";